import _ from 'lodash'
import axios from 'axios'

const isBrowser = typeof window !== 'undefined'

if (isBrowser) {
  window._ = _
  window.axios = axios
  window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
} else {
  // In Node.js environment
  global._ = _
  global.axios = axios
  global.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
}

// Export these for use in other files
export { _, axios }

// Echo setup (commented out for now)
// if (isBrowser) {
//   import('laravel-echo').then((Echo) => {
//     import('pusher-js').then((Pusher) => {
//       window.Pusher = Pusher.default
//       window.Echo = new Echo.default({
//         broadcaster: 'pusher',
//         key: import.meta.env.VITE_PUSHER_APP_KEY,
//         wsHost: import.meta.env.VITE_PUSHER_HOST ?? `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//         wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//         wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//         forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//         enabledTransports: ['ws', 'wss'],
//       })
//     })
//   })
// }
